@use "../../styles/Colors.scss" as Colors;

.dropdownButton {
	background-color: Colors.$col-transparent;
	border-color: Colors.$col-transparent;
	color: inherit;

	&:hover,
	&:focus,
	&:active,
	&:focus-visible,
	&:active:focus,
	&:active:hover {
		background-color: Colors.$col-transparent;
		background-image: none;
		border-color: Colors.$col-transparent;
		color: inherit;
		box-shadow: none;
		outline: none;
	}
}
